"use client";

import { Plus, Minus } from "lucide-react";
import { useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FAQ() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const [openItems, setOpenItems] = useState<string[]>([]);
  const faqs = [{
    id: "faq-1",
    question: "What types of experiences do you offer?",
    answer: "We curate exclusive eco-luxury experiences including boat excursions, cultural heritage tours, jungle adventures, cenote exploration, sunset cruises, and private yacht charters. Each experience blends adventure, culture, and Caribbean elegance."
  }, {
    id: "faq-2",
    question: "How do I book an experience?",
    answer: "You can book directly through our website or contact our concierge team at contact@ecoluxmaya.com or +52 984 123 4567. Our team is available Monday to Sunday from 8:00 AM to 8:00 PM to assist you."
  }, {
    id: "faq-3",
    question: "Are your tours suitable for families?",
    answer: "Yes, many of our experiences can be tailored for families. Our professional guides ensure safe, engaging activities for all ages while maintaining the luxury and exclusivity our brand is known for."
  }, {
    id: "faq-4",
    question: "What makes your experiences eco-luxury?",
    answer: "We are committed to sustainable tourism practices that preserve the environment while providing premium, curated experiences. All our tours follow strict eco-friendly guidelines and support local communities."
  }, {
    id: "faq-5",
    question: "Do you offer custom or private tours?",
    answer: "Absolutely. We specialize in creating tailor-made experiences that blend adventure and relaxation according to your preferences. Contact our concierge for personalized itinerary planning."
  }, {
    id: "faq-6",
    question: "What is your cancellation policy?",
    answer: "Cancellation policies vary by experience type. Please refer to your booking confirmation or contact our team for specific details. We strive to provide flexible options while maintaining service quality."
  }];
  return <section id="faq" ref={ref} className={`py-20 px-6 md:px-12 lg:px-20 bg-background transition-opacity duration-500 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="max-w-4xl mx-auto">
        <div className={`text-center mb-16 transition-all duration-700 delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="text-4xl md:text-5xl font-display text-foreground mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-muted max-w-2xl mx-auto">
            Find answers to common questions about our eco-luxury experiences in
            the Riviera Maya.
          </p>
        </div>

        <div className={`transition-all duration-700 delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Accordion type="multiple" value={openItems} onValueChange={setOpenItems} className="space-y-0">
            {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="border-b border-border/40 last:border-b-0">
                <AccordionTrigger className="text-left py-6 px-4 hover:bg-primary-light/30 rounded-lg transition-all duration-200 group">
                  <div className="flex items-start justify-between w-full gap-6">
                    <span className="text-lg font-semibold text-foreground pr-4 flex-1">
                      {faq.question}
                    </span>
                    <span className="flex-shrink-0 text-primary transition-transform duration-300 ease-out">
                      {openItems.includes(faq.id) ? <Minus className="size-5" /> : <Plus className="size-5" />}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="px-4 pb-6 pt-2 text-muted-foreground text-base leading-relaxed transition-all duration-300 ease-out">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}